// extracted by mini-css-extract-plugin
module.exports = {"main":"BaseLayout_main__cs6FQ"};